<template>
  <section class="career-list">
    <p class="total-found job-card">
      <span>{{ total }}</span>
      <span class="jobs-total"> {{ $fn.tr("Jobs Has Been Founed") }}</span>
    </p>
    <div class="job-heading">
      <div class="title">
        <p class="f-bold job-title">{{ $fn.tr("Job Title:") }}</p>
        <p class="f-bold job-description">{{ $fn.tr("Description:") }}</p>
        <p class="f-bold job-deadline">{{ $fn.tr("Deadline:") }}</p>
        <router-link class="explore hidden" to="#" tag="a">
          <p>{{ $fn.tr("Explore") }}</p>
          <IconComponent name="arrow-right" />
        </router-link>
      </div>
    </div>

    <template v-for="(item, index) in _.get(contentData, 'data.list')">
      <router-link
        :class="animation ? 'card-anim' : ''"
        :to="$store.getters['main/getSingleUrl'](item)"
        tag="div"
        class="job-card"
        :key="index"
      >
        <p class="job-title">{{ item.title }}</p>
        <p class="job-description">{{ item.description }}</p>
        <p class="job-deadline">
          {{ $moment(item.deadline).format("DD/M/YYYY") }}
        </p>
        <router-link
          class="explore"
          :to="$store.getters['main/getSingleUrl'](item)"
          tag="a"
        >
          <p>{{ $fn.tr("Explore") }}</p>
          <IconComponent name="arrow-right" />
        </router-link>
      </router-link>
    </template>
  </section>
</template>
<script>
import fn from "../../helpers/func";
import IconComponent from "../IconComponent.vue";

export default {
  props: ["contentData"],
  components: {
    IconComponent
  },
  data() {
    return {
      animation: true,
      totalList: null,
      totalItems: _.get(this.contentData, "data.listCount"),
      current_page:
        _.get(this.$store.state.main.selected_menu, "routeParams.paging") || 1
    };
  },
  mounted() {
    if (this.$route.fullPath.includes("paging")) {
      this.current_page = _.get(
        this.$store.state.main.selected_menu,
        "routeParams.paging"
      );
      setTimeout(() => {
        this.sendData();
      }, 500);
    }
  },
  watch: {
    filter: {
      immediate: true,
      handler: function() {
        this.sendData();
      }
    },
    current_page: {
      immediate: true,
      handler: function() {
        if (
          this.$route.path !=
          this.$store.getters["main/getPagingUrl"](this.current_page)
        ) {
          this.$router.push(
            this.$store.getters["main/getPagingUrl"](this.current_page)
          );
        }
      }
    }
  },
  computed: {
    deadline() {
      return moment(_.get(this.contentData, "data.list[0].deadline")).format(
        "DD/M/YYYY"
      );
    },
    page_size() {
      let tmp = _.get(this.contentData, "conf.page_count");
      return parseInt(tmp);
    },
    total: {
      get: function() {
        return this.totalItems
      },
      set: function(val) {
        this.totalItems = val;
      }
    },
    filter() {
      return this.$store.state.main.filter;
    }
  },
  methods: {
    async sendData() {
      this.animation = true;
      let params;
      params = {
        componentUnicId: _.get(this.contentData, "conf.unicId"),
        id: _.get(this.$store.state.main.selected_menu, "id"),
        searchText: this.filter.searchWord,
        pageNumber: this.current_page,
        taxonomies: {
          tags: this.filter.taxonomies.tags,
          category: this.filter.taxonomies.category
        }
      };
      let res = await fn.postData("main/getDataList", params);

      if (_.get(res, "data")) {
        setTimeout(() => {
          this.$set(this.contentData.data, "list", res.data.list);
          this.animation = false;
          this.total = res.data.listCount;
        }, 500);
      }
      return true;
    }
  }
};
</script>
<style lang="scss">
.career-list {
  .job-heading {
    background: var(--thirdy-tranparent);
    padding: 30px 0;
    width: 100%;
    .title {
      justify-content: space-between;
      display: flex;
      margin: 0 37px 0 30px;
      p {
        color: var(--bonus-txt);
        text-transform: capitalize;
      }
    }
  }
  .job-card {
    justify-content: space-between;
    display: flex;
    padding: 30px 0;
    margin: 0 37px 0 30px;
    border-bottom: 1px solid var(--thirdy-tranparent);
    &.card-anim {
      opacity: 0;
      transition: 0.4s ease-in-out;
    }
    @media (max-width: 833px) {
      margin: 0 20px;
    }
  }
  .job-card:not(.job-card:first-child) {
    cursor: pointer;
  }
  .job-title {
    width: 24%;
    margin-right: 30px;
    @media (max-width: 1365px) {
      max-width: 137px;
      width: 100%;
    }
    @media (max-width: 1023px) {
      max-width: 480px;
      width: 100%;
    }
    @media (max-width: 833px) {
      max-width: 480px;
      width: 100%;
    }
  }
  .job-description {
    width: 50%;
    margin-right: 30px;
    @media (max-width: 1023px) {
      display: none;
    }
  }
  .job-deadline {
    width: 10%;
    margin-right: 30px;
    @media (max-width: 833px) {
      width: fit-content;
      margin-right: 0;
    }
    @media (max-width: 833px) {
      width: fit-content;
      margin-right: 0;
    }
  }
  .explore {
    display: flex;
    align-items: center;
    @media (max-width: 833px) {
      display: none;
    }
    svg {
      margin-top: 5px;
      margin-left: 10px;
      path {
        fill: var(--bonus-txt);
      }
    }
    p {
      color: var(--bonus-txt);
      @media (max-width: 1720px) {
        display: none;
      }
    }
    &:hover {
      p {
        color: var(--secondary);
      }
      svg {
        path {
          fill: var(--secondary);
        }
      }
    }
  }
  .hidden {
    opacity: 0;
    pointer-events: none;
    @media (max-width: 833px) {
      display: none;
    }
  }
  .total-found {
    justify-content: flex-start;
  }
  .jobs-total {
    margin-left: 5px;
  }
}
</style>
